/* Pfeile der Artikelslider des Weissblau-Themes.
 *
 * Bewusst klein gehalten: das Wischen macht der Browser selbst (overflow-x: auto mit
 * scroll-behavior: smooth), die Pfeile schieben nur. Kein Karussell-Skript.
 *
 * Die Pfeile verschwinden, wenn alles passt - im Entwurf standen sie sonst ohne Funktion in der
 * Zeile. Der Test hat eine Toleranz, weil die Pfeile selbst Platz brauchen und der Zustand sonst
 * zwischen an und aus flattert.
 */
(() => {
  'use strict';

  const TOLERANZ = 8;

  function verbinden(spur) {
    if (spur.dataset.mhsysBereit) return;
    spur.dataset.mhsysBereit = '1';

    const abschnitt = spur.closest('section') || document;
    const pfeile = abschnitt.querySelector('[data-mhsys-slider-pfeile]');
    const zurueck = abschnitt.querySelector('[data-mhsys-slider-zurueck]');
    const weiter = abschnitt.querySelector('[data-mhsys-slider-weiter]');

    const schritt = () => Math.max(200, Math.round(spur.clientWidth * 0.8));
    if (zurueck) zurueck.addEventListener('click', () => (spur.scrollLeft -= schritt()));
    if (weiter) weiter.addEventListener('click', () => (spur.scrollLeft += schritt()));

    const pruefen = () => {
      if (!pfeile) return;
      const passt = spur.scrollWidth <= spur.clientWidth + TOLERANZ;
      pfeile.hidden = passt;
      if (passt) return;
      /* Pfeil ausgrauen, wenn in dieser Richtung nichts mehr kommt */
      const links = spur.scrollLeft;
      const rest = spur.scrollWidth - spur.clientWidth - links;
      if (zurueck) zurueck.disabled = links <= 2;
      if (weiter) weiter.disabled = rest <= 2;
    };

    spur.addEventListener('scroll', pruefen, { passive: true });
    window.addEventListener('resize', pruefen, { passive: true });
    /* im naechsten Bild: fonts.ready ist beim Start oft schon erfuellt, sofort gemessen erzwang das ein eigenes Layout */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => requestAnimationFrame(pruefen));
    requestAnimationFrame(pruefen);
  }

  function starten() {
    document.querySelectorAll('[data-mhsys-slider]').forEach(verbinden);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', starten);
  else starten();
  document.addEventListener('shopify:section:load', starten);
  /* Roadmap 3.8: fuer nachgeladene Slider (Neuheiten-Slider der Kollektion), deren Kacheln erst nach
     dem ersten Bild per Section Rendering API eintreffen - dieselbe Mechanik, nur erneut angestossen. */
  document.addEventListener('mhsys:slider:neu', starten);
})();
